<div class="questions-inline">

  <!-- Pills -->
  <div class="questions-chips p-mb-2">
    <span
      *ngFor="let q of resolvedQuestions; let i = index"
      class="question-chip"
      [title]="getQuestionLabel(q)"
    >
      <span class="chip-text">
        <span class="chip-id" *ngIf="q.id">({{ q.id }})</span>
        {{ getQuestionLabel(q) || q._id }}
      </span>
      <span class="chip-remove" (click)="removeQuestion(i)">✕</span>
    </span>
    <span *ngIf="!resolvedQuestions || resolvedQuestions.length === 0" class="no-items">
      No questions added yet.
    </span>
  </div>

  <!-- Multiselect input -->
  <p-multiSelect
    [ngModel]="resolvedQuestions"
    (ngModelChange)="onSelectionChange($event)"
    [options]="availableOptions"
    optionLabel="question"
    dataKey="_id"
    [filter]="true"
    filterBy="question,id"
    placeholder="Select questions..."
    selectedItemsLabel="{0} questions selected"
    [style]="{'width': '100%'}"
    appendTo="body"
  >
    <ng-template let-q pTemplate="item">
      <span>
        <span *ngIf="q.id" style="color:#868e96; margin-right:0.4rem;">({{ q.id }})</span>
        {{ q.question }}
      </span>
    </ng-template>
  </p-multiSelect>

  <div class="untagged-toggle p-mt-1" *ngIf="record?.type != null">
    <p-checkbox [(ngModel)]="includeUntagged" [binary]="true" inputId="includeUntagged" (onChange)="onIncludeUntaggedChange()"></p-checkbox>
    <label for="includeUntagged">Include untagged</label>
  </div>

</div>
